import { selectFilterSpec } from '@ow/utils'

export { selectFilterSpec as filterSpec }

export const config = {
  etc: true,
  hint: '请输入',
  slug: `select${Math.round(Math.random() * 100)}`,
  span: 1,
  type: 'select',
  title: '选择',
  layout: 'h',
  maxlen: 2,
  minlen: 2,
  random: false,
  remote: 'https://node-hnapi.herokuapp.com/news',
  render: '',
  default: {},
  selects: [
    {
      slug: '是',
      color: 'skyblue',
      intro: '',
      score: 0,
      title: '是',
      value: '是',
      checked: false,
      needInput: false,
      inputValue: '',
    },
  ],
  multiple: false,
  readonly: false,
  required: false,
  description: '备注显示区域：进行详细的解释说明。',
  rangeSetting: false,
  defaultChecked: [''],
  hiddenWhenCreate: true,
  showType: 'show',
}
